import { ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, Validator, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { AutenticacionService } from '../../services/autenticacion.service';
import { Firma_ElectronicaService } from 'src/app/services/firma_electronica.service';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { Listas } from 'src/app/models/generic/Listas';
import { RespuestaGenerica } from 'src/app/models/generic/RespuestaGenerica';
import { Firma_Electronica_CamposAdicionales } from 'src/app/models/generic/Firma_Electronica_CamposAdicionales';
import { Maestro_EstadoActualizar } from 'src/app/models/generic/Maestro_EstadoActualizar';
import { Firma_Electronica_CamposEnviar } from 'src/app/models/generic/Firma_Electronica_CamposEnviar';
import { Firma_Electronica_CamposAdicionalesDatos } from 'src/app/models/generic/Firma_Electronica_CamposAdicionalesDatos';
import { MatStepper } from '@angular/material/stepper';
import { timer } from 'rxjs';

@Component({
  selector: 'firma-electronica-generar',
  templateUrl: './firma-electronica-generar.component.html',
  styleUrls: ['./firma-electronica-generar.component.scss']
})
export class FirmaElectronicaGenerarComponent implements OnInit{
  
  form1: FormGroup;
  form2: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  @ViewChild('stepper', {static: false}) _stepper: MatStepper;
  listasCompletas: Listas[] = [];
  listasAliados: Listas[] = [];
  listasCanales: Listas[] = [];
  listasIndicativos: Listas[] = [];
  listasProductos: Listas[] = [];
  listasDocumentos: Listas[] = [];
  listasDepartamento: Listas[] = [];
  listasCiudades: Listas[] = [];
  listasTiposIdentificacion: Listas[] = [];
  listaCamposAdicionales: Listas[] = [];
  listaTopicosCamposAdicionales: Listas[] = [];
  listaFirmaElectronicaCampos: Firma_Electronica_CamposAdicionales[] = [];
  listaCondicionSiNo: Maestro_EstadoActualizar[] = [];
  confirmacionCodigo: boolean = false;
  mostrarPaso1: boolean = true;
  mostrarPaso2: boolean = false;
  mostrarPaso3: boolean = false;
  mostrarPaso4: boolean = false;
  mostrarReenviarCodigo: boolean = false;
  intervalReenviarCodigo;
  tiempoReenviarCodigo: number = 0;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Firma_ElectronicaService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService) {}

  ngOnInit() {
    this.listaCondicionSiNo = [];
    this.listaCondicionSiNo.push({ seleccionado: true, descripcion: 'Si' });
    this.listaCondicionSiNo.push({ seleccionado: false, descripcion: 'No' });

    this.ConsultarListas();
    this.IniciarFormulario();
    this.mostrarPaso1 = true;
    this.mostrarPaso2 = false;
    this.mostrarPaso3 = false;
    this.mostrarPaso4 = false;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.pauseTimerReenviarCodigo();
  }

  IniciarFormulario() {
    this.form1 = this.fb.group({
      tipoDocumento: ['', [Validators.required]],
      nroDocumento: ['', [Validators.required, Validators.maxLength(20)]],
      tipoDocumentoRepresentante: [''],
      nroDocumentoRepresentante: [''],
      nombres: [''],
      apellidos: [''],
      razonSocial: [''],
      codigoPaisIndicativo: ['', [Validators.required]],
      indicativo: [''],
      nroCelular: ['', [Validators.required, Validators.maxLength(20)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(50)]],
      idAliado: [0, [Validators.min(1)]],
      idCanal: [0, [Validators.min(1)]],
      idProducto: [0, [Validators.min(1)]],
      idProductoFirma: [0, [Validators.min(1)]],
    });

    this.IniciarFormulario2();
    this.EstablecerDatosAdicionalesRequeridos();
  }

  IniciarFormulario2() {
    this.form2 = this.fb.group({
      codigoAutorizacion: ['', [Validators.required, Validators.maxLength(10)]],
    });
  }

  EstablecerDatosAdicionalesRequeridos() {
    console.log('EstablecerDatosAdicionalesRequeridos');
    this.form1.get('tipoDocumentoRepresentante').setValidators([]);
    this.form1.get('nroDocumentoRepresentante').setValidators([]);
    this.form1.get('nombres').setValidators([]);
    this.form1.get('apellidos').setValidators([]);
    this.form1.get('razonSocial').setValidators([]);

    if (!this.TipoIdentificacionJuridico()) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      validatorsAdicionar.push(Validators.maxLength(100));
      this.form1.get('nombres').setValidators(validatorsAdicionar);
      this.form1.get('apellidos').setValidators(validatorsAdicionar);
    } else {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      validatorsAdicionar.push(Validators.maxLength(100));
      this.form1.get('tipoDocumentoRepresentante').setValidators(validatorsAdicionar);
      this.form1.get('nroDocumentoRepresentante').setValidators(validatorsAdicionar);
      this.form1.get('razonSocial').setValidators(validatorsAdicionar);
      this.form1.get('nombres').setValidators(validatorsAdicionar);
      this.form1.get('apellidos').setValidators(validatorsAdicionar);
    }

    this.form1.get('tipoDocumentoRepresentante').updateValueAndValidity();
    this.form1.get('nroDocumentoRepresentante').updateValueAndValidity();
    this.form1.get('nombres').updateValueAndValidity();
    this.form1.get('apellidos').updateValueAndValidity();
    this.form1.get('razonSocial').updateValueAndValidity();
  }

  GuardadoPaso1() {
    console.log('GuardadoPaso1', this.mostrarCargando);
    if (!this.mostrarCargando) {
      console.log('Formulario valido', this.form1.valid, this.form1);
      if (this.form1.valid) {
        this.mostrarPaso1 = false;
        this.mostrarPaso2 = true;
        this.mostrarPaso3 = false;
      } else {
        this.utilitariosService.MostrarErroresFormulario(this.form1);
      }
    }
  }
  AtrasPaso2() {
    if (!this.mostrarCargando) {
      this.mostrarPaso1 = true;
      this.mostrarPaso2 = false;
      this.mostrarPaso3 = false;
    }
  }
  GuardadoPas2() {
    if (!this.mostrarCargando) {
      if (this.listaFirmaElectronicaCampos.filter(x => !x.campoFormulario.valid && this.MostrarCampoDependiente(x.codigoCampo)).length === 0) {
        this._appconfirmacion.MostrarMensajeConfirmacion();
      } else {
        for (let index = 0; index < this.listaFirmaElectronicaCampos.length; index++) {
          let itemCampo = this.listaFirmaElectronicaCampos[index];
          this.utilitariosService.MostrarErroresFormularioControl(itemCampo.campoFormulario);
        }
      }
    }
  }
  AtrasPaso3() {
    this.mostrarPaso3 = false;
    this.mostrarPaso2 = true;
    this._stepper.previous();
  }
  GuardadoPaso3() {
    if (!this.mostrarCargando) {
      console.log('Formulario valido', this.form2.valid, this.form2);
      if (this.form2.valid) {
        this.EnviarDocumentoUsuario(false);
      } else {
        this.utilitariosService.MostrarErroresFormulario(this.form2);
      }
    } 
  }
  onKeyDownCodigoAutorizacion(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.GuardadoPaso3();
    }
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      this.EnviarDocumentoUsuario(this.confirmacionCodigo);
    }
  }
  EnviarDocumentoUsuario(esGeneracionCodigo: boolean = false, pasarStep: boolean = true) {
    this.mostrarCargando = true;

    console.log('EnviarDocumentoUsuario', esGeneracionCodigo);
    console.log(this.form1.value);

    let formularioGuardar = this.fb.group({
      tipoDocumento: [''],
      tipoDocumentoDescripcion: [''],
      nroDocumento: [''],
      tipoDocumentoRepresentante: [''],
      tipoDocumentoRepresentanteDescripcion: [''],
      nroDocumentoRepresentante: [''],
      nombres: [''],
      apellidos: [''],
      nombresCompleto: [''],
      razonSocial: [''],
      codigoPaisIndicativo: [''],
      pais: [''],
      indicativo: [''],
      nroCelular: [''],
      email: [''],
      idAliado: [0],
      aliado: [''],
      idCanal: [0],
      canal: [''],
      idProducto: [0],
      producto: [0],
      idProductoFirma: [0],
      productoFirma: [0],
      codigoAutorizacion: [''],
      camposAdicionales: [[]],
    });

    let listaValores: Firma_Electronica_CamposEnviar[] = [];

    console.log('EnviarDocumentoUsuario-campos', this.listaFirmaElectronicaCampos);
    if (this.utilitariosService.VerificarContieneDatosLista(this.listaFirmaElectronicaCampos)) {
      for (let index = 0; index < this.listaFirmaElectronicaCampos.length; index++) {
        let itemCampoFirma = this.listaFirmaElectronicaCampos[index];
        let itemCampoNuevo: Firma_Electronica_CamposEnviar = new Firma_Electronica_CamposEnviar();
        itemCampoNuevo.campo = itemCampoFirma.codigoCampo;
        itemCampoNuevo.tipoCampo = itemCampoFirma.tipoCampo;
        itemCampoNuevo.valor = '';
        itemCampoNuevo.descripcion = '';

        if (this.utilitariosService.VerificarContieneDatos(itemCampoFirma.campoFormulario.value)) {
          if (this.MostrarTipoCampoTexto(itemCampoFirma.tipoCampo)) {
            itemCampoNuevo.valor = itemCampoFirma.campoFormulario.value;
            itemCampoNuevo.descripcion = itemCampoFirma.campoFormulario.value;
          } else if (this.MostrarTipoCampoNumerico(itemCampoFirma.tipoCampo)) {
            itemCampoNuevo.valor = itemCampoFirma.campoFormulario.value.toString();
            itemCampoNuevo.descripcion = this.utilitariosService.TransformarNumerico(itemCampoFirma.campoFormulario.value);
          } else if (this.MostrarTipoCampoFecha(itemCampoFirma.tipoCampo)) {
            itemCampoNuevo.valor = this.utilitariosService.ObtenerFechaTextoSinHora(itemCampoFirma.campoFormulario.value);
            itemCampoNuevo.descripcion = this.utilitariosService.ObtenerFechaTextoSinHora(itemCampoFirma.campoFormulario.value);
          } else if (this.MostrarTipoCampoSiNo(itemCampoFirma.tipoCampo)) {
            itemCampoNuevo.valor = itemCampoFirma.campoFormulario.value.toString();
            itemCampoNuevo.descripcion = itemCampoFirma.campoFormulario.value ? 'SI' : 'NO';
          } else if (this.MostrarTipoCampoListaInterna(itemCampoFirma.tipoCampo) || this.MostrarTipoCampoListaTopico(itemCampoFirma.tipoCampo)) {
            itemCampoNuevo.valor = itemCampoFirma.campoFormulario.value.toString();
            let itemListaSeleccion = itemCampoFirma.listaDatos.filter(x => x.codigo === itemCampoFirma.campoFormulario.value)[0];
            if (this.utilitariosService.VerificarContieneDatos(itemListaSeleccion)) {
              itemCampoNuevo.descripcion = itemListaSeleccion.descripcion;
            }
          } else {
            itemCampoNuevo.valor = itemCampoFirma.campoFormulario.value.toString();
            itemCampoNuevo.descripcion = itemCampoFirma.campoFormulario.value.toString();
          }
        }

        listaValores.push(itemCampoNuevo);
      }
    }

    console.log('EnviarDocumentoUsuario-asigna valores formulario-1');

    formularioGuardar.get('tipoDocumento').setValue(this.form1.get('tipoDocumento').value);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-2');
    formularioGuardar.get('tipoDocumentoDescripcion').setValue(this.listasTiposIdentificacion.filter(x => x.codigo === this.form1.get('tipoDocumento').value)[0].descripcion);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-3');
    
    if (this.TipoIdentificacionJuridico()) {
      console.log('EnviarDocumentoUsuario-asigna valores formulario-4');
      formularioGuardar.get('nroDocumento').setValue(this.form1.get('nroDocumento').value);
      console.log('EnviarDocumentoUsuario-asigna valores formulario-5');
      formularioGuardar.get('tipoDocumentoRepresentante').setValue(this.form1.get('tipoDocumentoRepresentante').value);
      console.log('EnviarDocumentoUsuario-asigna valores formulario-6');
      formularioGuardar.get('tipoDocumentoRepresentanteDescripcion').setValue(this.listasTiposIdentificacion.filter(x => x.codigo === this.form1.get('tipoDocumentoRepresentante').value)[0].descripcion);
      console.log('EnviarDocumentoUsuario-asigna valores formulario-7');
      formularioGuardar.get('nroDocumentoRepresentante').setValue(this.form1.get('nroDocumentoRepresentante').value);
      console.log('EnviarDocumentoUsuario-asigna valores formulario-8');
      formularioGuardar.get('razonSocial').setValue(this.form1.get('razonSocial').value);
    } else {
      console.log('EnviarDocumentoUsuario-asigna valores formulario-4');
      formularioGuardar.get('nroDocumento').setValue('');
      console.log('EnviarDocumentoUsuario-asigna valores formulario-9');
      formularioGuardar.get('tipoDocumentoRepresentante').setValue(this.form1.get('tipoDocumento').value);
      console.log('EnviarDocumentoUsuario-asigna valores formulario-10');
      formularioGuardar.get('tipoDocumentoRepresentanteDescripcion').setValue(this.listasTiposIdentificacion.filter(x => x.codigo === this.form1.get('tipoDocumento').value)[0].descripcion);
      console.log('EnviarDocumentoUsuario-asigna valores formulario-11');
      formularioGuardar.get('nroDocumentoRepresentante').setValue(this.form1.get('nroDocumento').value);
      console.log('EnviarDocumentoUsuario-asigna valores formulario-12');
      formularioGuardar.get('razonSocial').setValue('');
    }
    
    console.log('EnviarDocumentoUsuario-asigna valores formulario-13');
    formularioGuardar.get('nombres').setValue(this.form1.get('nombres').value);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-14');
    formularioGuardar.get('apellidos').setValue(this.form1.get('apellidos').value);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-15');
    formularioGuardar.get('nombresCompleto').setValue(`${this.form1.get('nombres').value} ${this.form1.get('apellidos').value}`);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-16');
    formularioGuardar.get('codigoPaisIndicativo').setValue(this.form1.get('codigoPaisIndicativo').value);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-17');
    formularioGuardar.get('pais').setValue(this.listasIndicativos.filter(x => x.codigo === this.form1.get('codigoPaisIndicativo').value)[0].descripcion);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-18');
    formularioGuardar.get('indicativo').setValue(this.listasIndicativos.filter(x => x.codigo === this.form1.get('codigoPaisIndicativo').value)[0].id);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-19');
    formularioGuardar.get('nroCelular').setValue(this.form1.get('nroCelular').value);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-20');
    formularioGuardar.get('email').setValue(this.form1.get('email').value);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-21');
    formularioGuardar.get('idAliado').setValue(this.form1.get('idAliado').value);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-22');
    formularioGuardar.get('aliado').setValue(this.listasAliados.filter(x => x.id === this.form1.get('idAliado').value)[0].descripcion);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-23');
    formularioGuardar.get('idCanal').setValue(this.form1.get('idCanal').value);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-24');
    formularioGuardar.get('canal').setValue(this.listasCanales.filter(x => x.id === this.form1.get('idCanal').value)[0].descripcion);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-25');
    formularioGuardar.get('idProducto').setValue(this.form1.get('idProducto').value);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-26');
    formularioGuardar.get('producto').setValue(this.listasProductos.filter(x => x.id === this.form1.get('idProducto').value)[0].descripcion);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-27');
    formularioGuardar.get('idProductoFirma').setValue(this.form1.get('idProductoFirma').value);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-28');
    formularioGuardar.get('productoFirma').setValue(this.listasDocumentos.filter(x => x.id === this.form1.get('idProductoFirma').value)[0].descripcion);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-29');
    formularioGuardar.get('camposAdicionales').setValue(listaValores);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-30');
    formularioGuardar.get('codigoAutorizacion').setValue(this.form2.get('codigoAutorizacion').value);
    console.log('EnviarDocumentoUsuario-asigna valores formulario-31');

    if (esGeneracionCodigo) {
      console.log('EnviarDocumentoUsuario-llama metodo GenerarCodigo');
      this.mostrarReenviarCodigo = false;

      this.datosServices.GenerarCodigo(formularioGuardar.value)
      .subscribe((resp: RespuestaGenerica) =>{
        this.mostrarCargando = false;
        
        if (resp.procesoExitoso) {
          this.mostrarPaso1 = false;
          this.mostrarPaso2 = false;
          this.mostrarPaso3 = true;
          this.mostrarPaso4 = false;

          if (pasarStep) {
            this._stepper.next();
            this.IniciarFormulario2();
          }

          this.startTimerReenviarCodigo();
        } else {
          this.utilitariosService.MensajeToast(resp.mensaje);
          this.mostrarReenviarCodigo = true;
        }

        this.mostrarCargando = false;
      },
      (error: Error) => {
        console.log('EnviarDocumentoUsuario-error', error);
        this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
        this.mostrarCargando = false;
        this.cd.detectChanges();
      },
      () => this.cd.detectChanges());
    } else {
      console.log('EnviarDocumentoUsuario-llama metodo Actualizar');
      this.datosServices.Actualizar(formularioGuardar.value)
        .subscribe((resp: RespuestaGenerica) =>{
          this.mostrarCargando = false;
          
          if (resp.procesoExitoso) {
            this.mostrarPaso1 = false;
            this.mostrarPaso2 = false;
            this.mostrarPaso3 = false;
            this.mostrarPaso4 = true;

            this._stepper.next();
          } else {
            this.utilitariosService.MensajeToast(resp.mensaje);
          }

          this.mostrarCargando = false;
        },
        (error: Error) => {
          console.log('EnviarDocumentoUsuario-error', error);
          this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
          this.mostrarCargando = false;
          this.cd.detectChanges();
        },
        () => this.cd.detectChanges());
    }
  }
  ConsultarListas() {
    this.mostrarCargando = true;
    this.datosServices.ConsultarListas()
              .subscribe((resp: Listas[]) =>{
                this.mostrarCargando = false;
                this.listasCompletas = resp;
                
                this.listasAliados = this.listasCompletas.filter(x => x.lista === 'ALIADOS');
                this.listasIndicativos = this.listasCompletas.filter(x => x.lista === 'INDICATIVOS');
                this.listasDepartamento = this.listasCompletas.filter(x => x.lista === 'PROVINCIAS');
                this.listasTiposIdentificacion = this.listasCompletas.filter(x => x.lista === 'TIPOS_IDENTIFICACION');
                this.listaCamposAdicionales = this.listasCompletas.filter(x => x.lista === 'CAMPOS_FIRMAELECTRONICA');

                if (this.listasAliados.length === 1) {
                  this.form1.get('idAliado').setValue(this.listasAliados[0].id);
                }
                if (this.listasIndicativos.length === 1) {
                  this.form1.get('codigoPaisIndicativo').setValue(this.listasIndicativos[0].codigo);
                }
            
                this.RecargarListaCanales();
                this.RecargarListaProductos();
                this.Cambio_Producto();

                this.mostrarCargando = false;
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  Cambio_Aliado() {
    this.RecargarListaCanales();
    this.RecargarListaProductos();
  }
  RecargarListaCanales() {
    this.listasCanales = this.listasCompletas.filter(x => x.lista === 'CANALES' && x.dependienciaId === this.form1.get('idAliado').value);

    if (this.listasCanales.length === 1) {
      this.form1.get('idCanal').setValue(this.listasCanales[0].id);
    }
  }
  RecargarListaProductos() {
    this.listasProductos = this.listasCompletas.filter(x => x.lista === 'MAESTRO_PRODUCTOS' && x.dependienciaId === this.form1.get('idAliado').value);

    if (this.listasProductos.length === 1) {
      this.form1.get('idProducto').setValue(this.listasProductos[0].id);
    }
    this.RecargarListaDocumentos();
  }
  RecargarListaDocumentos() {
    this.listasDocumentos = this.listasCompletas.filter(x => x.lista === 'DOCUMENTOS_FIRMAELECTRONICA' && x.dependienciaId === this.form1.get('idAliado').value && x.condicionEntero1 === this.form1.get('idProducto').value);

    if (this.listasDocumentos.length === 1) {
      this.form1.get('idProductoFirma').setValue(this.listasDocumentos[0].id);
      this.Cambio_DocumentoFirma();
    }
  }
  ObtenerCodigoBandera(codigoIndicativo: string): string {
    let imagenRetorno: string = '';
    if (this.listasIndicativos) {
      if (this.listasIndicativos.filter(x => x.codigo === codigoIndicativo).length > 0) {
        imagenRetorno = this.listasIndicativos.filter(x => x.codigo === codigoIndicativo)[0].dependenciaCodigo;
      }
    }
    return imagenRetorno;
  }
  ObtenerIndicativo(codigoIndicativo: string): string {
    let imagenRetorno: string = '';
    if (this.listasIndicativos) {
      if (this.listasIndicativos.filter(x => x.codigo === codigoIndicativo).length > 0) {
        imagenRetorno = this.listasIndicativos.filter(x => x.codigo === codigoIndicativo)[0].id.toString();
      }
    }
    return imagenRetorno;
  }
  Cambio_TipoDocumento() {
    this.EstablecerDatosAdicionalesRequeridos();
  }
  Cambio_Producto() {
    let itemProducto = this.listasProductos.filter(x => x.id === this.form1.get('idProducto')?.value)[0];
    let asignoCanal: boolean = false;
    this.RecargarListaDocumentos();
    
    if (this.utilitariosService.VerificarContieneDatos(itemProducto)) {
      if (this.utilitariosService.VerificarContieneDatosNumerico(itemProducto.condicionEntero1)) {
        this.form1.get('idCanal')?.setValue(itemProducto.condicionEntero1);
        asignoCanal = true;
      }
    }

    if (!asignoCanal) {
      if (this.utilitariosService.VerificarContieneDatosLista(this.listasCanales)) {
        this.form1.get('idCanal')?.setValue(this.listasCanales[0].id);
      }
    }

    this.EstablecerDatosAdicionalesRequeridos();
  }
  Cambio_DocumentoFirma() {
    let itemProducto = this.listasDocumentos.filter(x => x.id === this.form1.get('idProductoFirma')?.value)[0];
    this.confirmacionCodigo = false;

    if (this.utilitariosService.VerificarContieneDatos(itemProducto)) {
      this.confirmacionCodigo = itemProducto.condicionLogica1;
    }

    this.listaFirmaElectronicaCampos = [];
    let listaCampos = this.listaCamposAdicionales.filter(x => x.dependienciaId === this.form1.get('idAliado')?.value && x.condicionEntero1 === this.form1.get('idProductoFirma')?.value);
    for (let index = 0; index < listaCampos.length; index++) {
      let itemCampo = listaCampos[index];
      let itemCampoFirma: Firma_Electronica_CamposAdicionales = new Firma_Electronica_CamposAdicionales();
      itemCampoFirma.id = itemCampo.id;
      itemCampoFirma.codigoCampo = itemCampo.codigo;
      itemCampoFirma.descripcionCampo = itemCampo.condicionLogica1 ? `${itemCampo.descripcion} (*)` : itemCampo.descripcion;
      itemCampoFirma.tipoCampo = itemCampo.dependenciaCodigo;
      itemCampoFirma.datosConfiguracion = itemCampo.condicionString1;
      itemCampoFirma.codigoCampoDependiente = itemCampo.condicionString2;
      itemCampoFirma.listaDatosCompleta = [];
      itemCampoFirma.listaDatos = [];
      
      if (this.MostrarTipoCampoNumerico(itemCampoFirma.tipoCampo)) {
        if (this.utilitariosService.VerificarContieneDatosNumerico(itemCampo.condicionEntero2)) {
          itemCampoFirma.campoFormulario = new FormControl(itemCampo.condicionEntero2);
        } else {
          itemCampoFirma.campoFormulario = new FormControl(0);
        }
      } else if (this.MostrarTipoCampoFecha(itemCampoFirma.tipoCampo)) {
        itemCampoFirma.campoFormulario = new FormControl(new Date());
      } else if (this.MostrarTipoCampoSiNo(itemCampoFirma.tipoCampo)) {
        itemCampoFirma.campoFormulario = new FormControl(false);
      } else {
        itemCampoFirma.campoFormulario = new FormControl('');
      }

      if (itemCampo.condicionLogica1) {
        if (this.MostrarTipoCampoNumerico(itemCampoFirma.tipoCampo)) {
          let validatorsAdicionar = [];
          validatorsAdicionar.push(Validators.required);
          validatorsAdicionar.push(Validators.min(1));
          itemCampoFirma.campoFormulario.setValidators(validatorsAdicionar);
        } else {
          let validatorsAdicionar = [];
          validatorsAdicionar.push(Validators.required);
          itemCampoFirma.campoFormulario.setValidators(validatorsAdicionar);
        }
      }

      if (this.utilitariosService.VerificarContieneDatosTexto(itemCampoFirma.datosConfiguracion)) {
        if (this.MostrarTipoCampoListaTopico(itemCampoFirma.tipoCampo)) {
          var listaTopicoValidar = this.listasCompletas.filter(x => x.lista === itemCampoFirma.datosConfiguracion && (!this.utilitariosService.VerificarContieneDatosNumerico(x.dependienciaId) || (this.utilitariosService.VerificarContieneDatosNumerico(x.dependienciaId) && x.dependienciaId === this.form1.get('idAliado')?.value)));
          let listaDatosAdignar: Firma_Electronica_CamposAdicionalesDatos[] = [];

          for (let index = 0; index < listaTopicoValidar.length; index++) {
            let itemTopico = listaTopicoValidar[index];
            let itemAgregarTopico: Firma_Electronica_CamposAdicionalesDatos = new Firma_Electronica_CamposAdicionalesDatos();
            itemAgregarTopico.codigo = itemTopico.codigo;
            itemAgregarTopico.descripcion = itemTopico.descripcion;
            itemAgregarTopico.codigoDependiente = itemTopico.dependenciaCodigo;

            listaDatosAdignar.push(itemAgregarTopico);
          }

          itemCampoFirma.listaDatosCompleta = listaDatosAdignar;
          if (!this.utilitariosService.VerificarContieneDatosTexto(itemCampoFirma.codigoCampoDependiente)) {
            itemCampoFirma.listaDatos = listaDatosAdignar;
          }

          if (this.utilitariosService.VerificarContieneDatos(itemCampoFirma.listaDatos)) {
            if (itemCampoFirma.listaDatos.length === 1) {
              itemCampoFirma.campoFormulario.setValue(itemCampoFirma.listaDatos[0].codigo);
            }
          }
        } else if (this.MostrarTipoCampoListaInterna(itemCampoFirma.tipoCampo)) {
          var listaDatosInterno = itemCampo.condicionString1.split('|');
          itemCampoFirma.listaDatos = [];
          let listaDatosAdignar: Firma_Electronica_CamposAdicionalesDatos[] = [];

          for (let index = 0; index < listaDatosInterno.length; index++) {
            let itemDatos = listaDatosInterno[index];
            let datosAsignacion = itemDatos.split('=');
            let itemAgregarDatos: Firma_Electronica_CamposAdicionalesDatos = new Firma_Electronica_CamposAdicionalesDatos();
            itemAgregarDatos.codigo = datosAsignacion[0];
            itemAgregarDatos.descripcion = datosAsignacion[1];
            itemAgregarDatos.codigoDependiente = datosAsignacion[2];

            listaDatosAdignar.push(itemAgregarDatos);
          }

          itemCampoFirma.listaDatosCompleta = listaDatosAdignar;
          if (!this.utilitariosService.VerificarContieneDatosTexto(itemCampoFirma.codigoCampoDependiente)) {
            itemCampoFirma.listaDatos = listaDatosAdignar;
          }

          if (this.utilitariosService.VerificarContieneDatos(itemCampoFirma.listaDatos)) {
            if (itemCampoFirma.listaDatos.length === 1) {
              itemCampoFirma.campoFormulario.setValue(itemCampoFirma.listaDatos[0].codigo);
            }  
          }
        }
      }
      
      this.listaFirmaElectronicaCampos.push(itemCampoFirma);
    }

    this.EstablecerDatosAdicionalesRequeridos();
  }
  TipoIdentificacionJuridico(): boolean {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listasTiposIdentificacion)) {
      let itemTipoIdentificacion = this.listasTiposIdentificacion.filter(x => x.codigo === this.form1.get('tipoDocumento')?.value)[0];
      if (this.utilitariosService.VerificarContieneDatos(itemTipoIdentificacion)) {
        if (itemTipoIdentificacion.codigo === '31') {
          return true;
        }
      }
    }
    return false;
  }
  MostrarCampoDependiente(campo: string): boolean {
    let itemCampo = this.listaFirmaElectronicaCampos.filter(x => x.codigoCampo === campo)[0];
    if (this.utilitariosService.VerificarContieneDatos(itemCampo)) {
      let itemCampoDependiente = this.listaFirmaElectronicaCampos.filter(x => x.codigoCampo === itemCampo.codigoCampoDependiente)[0];
      if (this.utilitariosService.VerificarContieneDatos(itemCampoDependiente)) {
        if (this.MostrarTipoCampoSiNo(itemCampoDependiente.tipoCampo)) {
          if (!itemCampoDependiente.campoFormulario.value) {
            return false;
          }
        }
      }
    }
    return true;
  }
  MostrarTipoCampoTexto(tipoCampo: string): boolean {
    return tipoCampo === 'TEXTO';
  }
  MostrarTipoCampoNumerico(tipoCampo: string): boolean {
    return tipoCampo === 'NUMERICO';
  }
  MostrarTipoCampoNumero(tipoCampo: string): boolean {
    return tipoCampo === 'NUMERO';
  }
  MostrarTipoCampoFecha(tipoCampo: string): boolean {
    return tipoCampo === 'FECHA';
  }
  MostrarTipoCampoSiNo(tipoCampo: string): boolean {
    return tipoCampo === 'SI/NO' || tipoCampo === 'SI/NO_2';
  }
  MostrarTipoCampoLista(tipoCampo: string): boolean {
    return this.MostrarTipoCampoListaTopico(tipoCampo) || this.MostrarTipoCampoListaInterna(tipoCampo);
  }
  MostrarTipoCampoListaTopico(tipoCampo: string): boolean {
    return tipoCampo === 'LISTATOPICO';
  }
  MostrarTipoCampoListaInterna(tipoCampo: string): boolean {
    return tipoCampo === 'LISTAINTERNA';
  }

  CambioItemFormularioDinamico(itemFormularioCampo: Firma_Electronica_CamposAdicionales) {
    console.log('CambioItemFormularioDinamico', itemFormularioCampo);
    let listaCamposDependientes = this.listaFirmaElectronicaCampos.filter(x => x.codigoCampoDependiente === itemFormularioCampo.codigoCampo);
    for (let index = 0; index < listaCamposDependientes.length; index++) {
      let itemCampoFirma = listaCamposDependientes[index];
      itemCampoFirma.campoFormulario.setValue('');
      itemCampoFirma.listaDatos = itemCampoFirma.listaDatosCompleta.filter(x => x.codigoDependiente === itemFormularioCampo.campoFormulario.value);
    }
  }

  PasoDatosComplementariosValidos(): boolean {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listaFirmaElectronicaCampos)) {
      let retornoValido: boolean = true;
      for (let index = 0; index < this.listaFirmaElectronicaCampos.length; index++) {
        let item = this.listaFirmaElectronicaCampos[index];
        if (!item.campoFormulario.valid) {
          retornoValido = false;
          break;
        }
      }

      return retornoValido;
    }
    return false;
  }

  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo(this.autenticacionService.Componente);
  }

  LimpiarPaso1() {
    this.IniciarFormulario();

    if (this.listasAliados.length === 1) {
      this.form1.get('idAliado').setValue(this.listasAliados[0].id);
      this.Cambio_Aliado();
    }
    if (this.listasIndicativos.length === 1) {
      this.form1.get('codigoPaisIndicativo').setValue(this.listasIndicativos[0].codigo);
    }
  }

  ReenviarCodigoAutorizacion() {
    this.pauseTimerReenviarCodigo();
    this.EnviarDocumentoUsuario(true, false);
  }

  startTimerReenviarCodigo() {
    this.tiempoReenviarCodigo = 60;
    this.intervalReenviarCodigo = setInterval(() => {
      this.tiempoReenviarCodigo -= 1;
      if (this.tiempoReenviarCodigo <= 0) {
        this.mostrarReenviarCodigo = true;
        this.pauseTimerReenviarCodigo();
      }
    },1000)
  }

  pauseTimerReenviarCodigo() {
    clearInterval(this.intervalReenviarCodigo);
  }
}
